import {initTopPanelSearchInSuggestOracle, initTopPanelSearchSuggestOracle} from "../widgets/TopPanelSearchSuggestOracle"
import * as kendoThemeChooser from "./KednoThemeChooser";
import {currentFontSize, currentFontType} from "./KednoThemeChooser";
import {ajaxJSON, isNullOrUndefined, noMenu} from "../common/NamaCommon";
import * as urls from "../constants/NamaURLS";
import {currentLegalEntity, currentUserId, currentUserName, dynPrefix, dynSuffix, initThemesField} from "../login/LoginPresenter";
import * as notifier from "../common/ErrorsNotification";
import * as ts from "../common/Translator";
import {isArabic, translateId} from "../common/Translator";
import NavBarTemplate, {bodyTemplateApproval, bodyTemplateNotification} from "../compiled-templates/NavBarTemplate";
import {downloadURL} from "../common/AttachmentLinkUtil";
import * as app from '../views/mainapp'
import {NamaKendoWindow} from '../views/NamaKendoWindow'
import {QuestionFieldsEditor} from "../widgets/QuestionFieldsEditor";
import * as DomainBaseEntities from "../constants/DomainBaseEntities";
import * as FieldType from "../constants/FieldType";
import {questionFiled} from "./edit/EditScreenMoreMenu";
import {changeLocale_, logout} from "../login/Security";
import {backToOldGui, genQRCodeForUserInfo} from "../common/GUIUtilities";
import {NaMaAboutDialog} from "./NaMaAboutDialog";
import {applicationVersion} from "../common/DefaultApplicationInfo";
import {NamaRouterInstance} from "../routing/NamaRouter";
import * as places from "../routing/places";
import * as ApprovalsAndNotifications from "../widgets/ApprovalsAndNotifications";
import {showChangeDimsDialog} from "../widgets/ApprovalsAndNotifications";
import {getCustomGUISettings} from "../login/ClientCache";

export function render() {
    return $(NavBarTemplate({
        translateId: ts.translateId,
        appVersion: applicationVersion(),
        smLogoImg: window.branding === 'exceed' ? dynPrefix() + "images/exceed-logo.svg" + dynSuffix() :
            window.branding === 'capital' ? dynPrefix() + "images/capital-logo.svg" + dynSuffix() :
                window.branding === 'softvision' ? dynPrefix() + "images/softvision-logo.svg" + dynSuffix() :
                    window.branding === 'autopractice' ? dynPrefix() + "images/autopractice-logo.svg" + dynSuffix() :
                    dynPrefix() + "images/logo.svg" + dynSuffix()
    }))
}

export function timedQueryChanged(result) {
    let event = new CustomEvent('timeQueryEvent', {detail: result});
    document.dispatchEvent(event);
}


function attachEventToTimeQueryLabel(element) {
    document.addEventListener("timeQueryEvent", function (event) {
        $(element).html(event.detail);
    });
}

let aboutDialog;

function attachEventToApplicationInfoBtn(element) {
    element.on("click", (e) => {
        e.preventDefault();
        if (!aboutDialog)
            aboutDialog = new NaMaAboutDialog();
        aboutDialog.show();
    });
}

function initCompanyNameIfNeeded(element) {
    let showCompanyNameNextToLogo = getCustomGUISettings().showCompanyNameNextToLogo;
    let companyName = window.companyName;
    if (isNullOrUndefined(showCompanyNameNextToLogo) || !showCompanyNameNextToLogo || !companyName)
        return;
    element.empty();
    element.text(companyName);
}

export function initGoToHome(btn) {
    btn.attr('title', ts.translateId('homePage'));
    btn.click(function (e) {
        e.preventDefault();
        NamaRouterInstance.goTo(new places.WelcomePlace());
    });
}

export function afterAttach() {
    let navbar = $("#nama-erp-header");
    $("#menu").kendoMenu({
        open: () => {
            setTimeout(() => {
                let $menu = $("#menu .k-child-animation-container");
                console.log($menu[0]);
                $menu.css("width", "");
            })
        }
    });
    initTopPanelSearchSuggestOracle(navbar.find("#headerSearch"));
    initTopPanelSearchSuggestOracle(navbar.find("#headerSearchMobile"));
    initTopPanelSearchInSuggestOracle(navbar.find("#headerSearchIn"));
    initTopPanelSearchInSuggestOracle(navbar.find("#headerSearchInMobile"));
    initNavbarApprovalAndNotificationButtons(navbar);
    initLogoutBtn(navbar.find("#LogoutBtn"));
    initChangePasswordBtn(navbar.find("#changePassword"));
    initLangBtn(navbar.find("#lang_btn"));
    initBackToOldGui(navbar.find("#backToOldGui"));
    initGoToHome(navbar.find("#goToHome"));
    initThemesField(navbar.find("#colors"));
    attachUserImageToBar(navbar.find("#userImg1"));
    attachUserImageToBar(navbar.find("#userImg2"));
    initCompanyNameIfNeeded(navbar.find("#applicationInfo"));
    attachEventToApplicationInfoBtn(navbar.find("#applicationInfo"));
    attachEventToTimeQueryLabel(navbar.find("#navbarSupportedContent"))
    initGenQRCode(navbar);
    initUserAndCompanyName(navbar);
    initFontSizeAndFamily(navbar);
    createPopover(navbar);
}

function initFontSizeAndFamily(navbar) {
    navbar.find("#fontSize").kendoDropDownList({
        filter: "startswith",
        dataTextField: "text",
        dataValueField: "value",
        dataSource: [
            {text: "8px", value: "8px"},
            {text: "9px", value: "9px"},
            {text: "10px", value: "10px"},
            {text: "11px", value: "11px"},
            {text: "12px", value: "12px"},
            {text: "13px", value: "13px"},
            {text: "14px", value: "14px"},
            {text: "15px", value: "15px"},
            {text: "16px", value: "16px"},
            {text: "17px", value: "17px"},
            {text: "18px", value: "18px"},
            {text: "19px", value: "19px"},
            {text: "20px", value: "20px"},
            {text: "21px", value: "21px"},
            {text: "22px", value: "22px"},
            {text: "23px", value: "23px"},
            {text: "24px", value: "24px"},
            {text: "25px", value: "25px"}
        ],
        value: currentFontSize(),
        change(e) {
            let value = navbar.find("#fontSize").kendoDropDownList("value");
            kendoThemeChooser.changeFontSize(value);

        }
    }).data("kendoDropDownList");

    navbar.find("#fontFamily").kendoDropDownList({
        filter: "startswith",
        value: currentFontType(),
        dataSource: ['Default', 'Times New Roman', 'serif', 'Arial', 'georgia', 'fantasy', 'monospace', 'helvetica', 'cursive', 'tahoma', 'lato', 'Verdana'
            , 'Amiri', 'Droid Arabic Kufi', 'Droid Arabic Naskh', 'Lateef', 'Scheherazade', 'Thabit'],
        change(e) {
            let value = navbar.find("#fontFamily").kendoDropDownList("value");
            kendoThemeChooser.changeFontType(value);
        }
    }).data("kendoDropDownList");
}

function initUserAndCompanyName(navbar) {
    navbar.find('.currentUserName').html(currentUserName());
    navbar.find('#currentLegalEntity').text(currentLegalEntity());
    navbar.find("#currentLegalEntity").click(function (e) {
        e.preventDefault();
        showChangeDimsDialog();
    });
}

function initHomePage(homePage) {
    homePage.click(function (e) {
        e.preventDefault();
        NamaRouterInstance.goTo(new places.WelcomePlace());
    });
}

function initGenQRCode(navbar) {
    let genQRCode = navbar.find("#undoQrCode");
    genQRCode.attr('title', ts.translateId('genQrCode'));
    genQRCode.click(function (e) {
        e.preventDefault();
        genQRCodeForUserInfo(genQRCode);
        navbar.find(".k-overlay").fadeIn();
    });
}

function initBackToOldGui(backToOld) {
    backToOld.attr('title', ts.translateId('tryNewVersion'));
    let icon = backToOld.find("i");
    backToOld.on("mouseover", (e) => {
        icon.removeClass("fa-frown-o");
        icon.addClass("fa-smile-o");
    });
    backToOld.on("mouseout", (e) => {
        icon.removeClass("fa-smile-o");
        icon.addClass("fa-frown-o");
    });
    backToOld.click(function (e) {
        e.preventDefault();
        backToOldGui(e.ctrlKey || e.altKey);
    });
}

function attachUserImageToBar(element) {
    let fileId = app.instance.loginInfo.userInfo.mainFile.attachmentInfo.fileId;
    let imgSrc = downloadURL(fileId, "User", "THUMBNAIL", false) + "&userImage=true";
    element.attr("src", imgSrc);
}

function initLangBtn(langBtn) {
    langBtn.click(function (e) {
        changeLocale_();
    });
}

function initChangePasswordBtn(btn) {
    btn.kendoButton({
            click: function (e) {
                createAndShowPopup();
            }
        }
    );
}

export function findQuestionFieldVal(filledQuestionFields, fieldId) {
    for (let question of filledQuestionFields) {
        if (question.id === fieldId)
            return question.value;
    }
    return null;
}

export function findQuestionObjFieldVal(filledQuestionFields, fieldId) {
    for (let question of filledQuestionFields) {
        if (question.id === fieldId)
            return question.objValue;
    }
    return null;
}

function createAndShowPopup() {
    let questionFieldsEditor = new QuestionFieldsEditor(DomainBaseEntities.User);
    /**
     *
     * @type {namaTypes.NamaWindowBtnData}
     */
    let okBtnData = {
        btnTitle: "ok", btnAction: () => {
            let filledQuestionFields = questionFieldsEditor.getQuestionFields();
            let userImgAttachmentInfo = findQuestionObjFieldVal(filledQuestionFields, "userImage") ? findQuestionObjFieldVal(filledQuestionFields, "userImage").attachmentInfo : {};
            let changePasswordInfo =
                {
                    userIdToChangePasswordFor: currentUserId(),
                    newPassword: findQuestionFieldVal(filledQuestionFields, "password"),
                    confirmPassword: findQuestionFieldVal(filledQuestionFields, "confirmNewPassword"),
                    userEmail: findQuestionFieldVal(filledQuestionFields, "userEmail"),
                    emailPassword: findQuestionFieldVal(filledQuestionFields, "emailPassword"),
                    imageName: userImgAttachmentInfo.fileName,
                    passwordMustBeChanged: false
                };
            ajaxJSON(urls.Change_Password, {
                    changePasswordInfo: JSON.stringify(changePasswordInfo),
                    userImageFileId: userImgAttachmentInfo.fileId
                }, () => {
                    changePasswordWindow.closeWindow();
                    notifier.showSuccess(translateId("operationSuccessfull"));
                    app.instance.loginPresenter.initLoginModal();
                }
            );
        }
    };
    /**
     *
     * @type {namaTypes.NamaWindowBtnData}
     */
    let cancelBtnData = {
        btnTitle: "cancel"
    };
    let changePasswordWindow = new NamaKendoWindow("Change Password", okBtnData, cancelBtnData);
    let questionFields = [];
    questionFields.push(questionFiled("currentPassword", null, FieldType.Password));
    questionFields.push(questionFiled("password", null, FieldType.Password));
    questionFields.push(questionFiled("confirmNewPassword", null, FieldType.Password));
    questionFields.push(questionFiled("userEmail", null, FieldType.Text));
    questionFields.push(questionFiled("emailPassword", null, FieldType.Password));
    questionFields.push(questionFiled("userImage", null, FieldType.Binary));
    questionFieldsEditor.edit(questionFields, null, null, null, null, changePasswordWindow);
    changePasswordWindow.height = "35%";
    changePasswordWindow.showWindow();
}

let notificationData;
let acceptData;

function initNavbarApprovalAndNotificationButtons(navbar) {
    navbar.find("#topheadermenu").kendoMenu();
    let notificationAnchor = navbar.find("#notifications");
    notificationAnchor.attr('title', ts.translateId('notifications'));
    notificationData = $("#notificationsPopup").kendoPopup({
        anchor: notificationAnchor
    }).data("kendoPopup");
    notificationAnchor.click(function (e) {
        e.preventDefault();
        notificationData.toggle();
    });
    let approvalsAnchor = navbar.find("#accept");
    approvalsAnchor.attr('title', ts.translateId('menuApprovals'));
    acceptData = $("#acceptPopup").kendoPopup({
        anchor: approvalsAnchor
    }).data("kendoPopup");
    approvalsAnchor.click(function (e) {
        e.preventDefault();
        acceptData.toggle();
    });
}

function initLogoutBtn(logoutBtn) {
    logoutBtn.kendoButton({
        click: (e) => (
            logout())
    })
}

function handMenuToggleBtn(navbar) {
    if (noMenu())
        return;
    let menu = $("#menu");
    let API = menu.data("mmenu");
    if (!API) {
        setTimeout(() => handMenuToggleBtn(navbar), 1000);
        return;
    }
    let showHideBtnKlass = isArabic() ? "fa-chevron-left" : "fa-chevron-right";
    navbar.find("#butShowHide").find("i").addClass(showHideBtnKlass);
    navbar.find("#butShowHide").click(() => {
        if (!menu.attr("toggleButtonClickHandled")) {
            menu.attr("toggleButtonClickHandled", "true");
            API.bind('open:start', () => {
                changeShowHideBtn($("#butShowHide").find("i"));
            });
            API.bind('close:finish', () => {
                changeShowHideBtn($("#butShowHide").find("i"));
            });
        }
        if (menu.hasClass("mm-opened"))
            API.close();
        else
            API.open();
    });
}

function changeShowHideBtn(element) {
    let leftKlass = "fa-chevron-left";
    let rightKlass = "fa-chevron-right";
    if (element.hasClass(leftKlass)) {
        element.removeClass(leftKlass);
        element.addClass(rightKlass);
        return;
    }
    if (element.hasClass(rightKlass)) {
        element.removeClass(rightKlass);
        element.addClass(leftKlass);

    }

}

function createPopover(navbar) {
    $(".btn-popover-not").kendoPopover({
        filter: "button",
        showOn: "click",
        width: "300px",
        position: "right",
        body: kendo.template($(bodyTemplateNotification()).html()),
        actionsPosition: "evenly",
        show: function () {
            ApprovalsAndNotifications.initNotificationsEvents(navbar);
        }
    });

    $(".btn-popover-accept").kendoPopover({
        filter: "button",
        showOn: "click",
        width: "300px",
        position: "right",
        body: kendo.template($(bodyTemplateApproval()).html()),
        actionsPosition: "evenly",
        show: function () {
            ApprovalsAndNotifications.initApprovalsEvents();
        }
    });
}
